var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { TextDialog } from './styles';
var TextOverlay = /** @class */ (function (_super) {
    __extends(TextOverlay, _super);
    function TextOverlay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextOverlay.prototype.render = function () {
        var _a = this.props, open = _a.open, text = _a.text, fontSize = _a.fontSize, textColor = _a.textColor, backgroundColor = _a.backgroundColor;
        var themeProps = {
            fontSize: fontSize,
            textColor: textColor,
            backgroundColor: backgroundColor
        };
        return (React.createElement(TextDialog, { open: open, disableBackdropClick: true, theme: themeProps }, text));
    };
    return TextOverlay;
}(React.Component));
export { TextOverlay };
